export default {
  SET_CURRENT_USER (state, currentUserData) {
    state.currentUser = currentUserData
  },
  SET_LOGIN_STATE (state, loginState) {
    state.login = loginState;
  },
  SET_USER_INFO (state, user) {
    
  },
  SET_VIEW(state, view) {
    state.view = view;
  }
}
